import type { CSSProperties } from "react";

/** 订单详情页布局配置（仅本页生效） */
export interface SpaceMineOrderDetailConfig {
  /** 底部支付栏额外 bottom padding（px），增大后按钮整体上移 */
  footBottomPaddingExtra: number;
}

const FOOT_PADDING_TOP = 12;
const FOOT_PADDING_BOTTOM_BASE = 12;
const FOOT_BUTTON_HEIGHT = 48;
/** 页面底部留白 = 顶内边距 + 按钮高 + 底内边距 + 缓冲 */
const PAGE_PADDING_BOTTOM_BASE =
  FOOT_PADDING_TOP + FOOT_BUTTON_HEIGHT + FOOT_PADDING_BOTTOM_BASE + 16;

export const SPACE_MINE_ORDER_DETAIL = {
  footBottomPaddingExtra: 30,
} as const satisfies SpaceMineOrderDetailConfig;

/** 注入订单详情根节点，控制底部支付栏与页面留白 */
export function spaceMineOrderDetailCssVars(): CSSProperties {
  const extra = SPACE_MINE_ORDER_DETAIL.footBottomPaddingExtra;
  const footPaddingBottom = FOOT_PADDING_BOTTOM_BASE + extra;
  const pagePaddingBottom = PAGE_PADDING_BOTTOM_BASE + extra;
  return {
    ["--h5-order-detail-foot-padding-bottom" as string]: `${footPaddingBottom}px`,
    ["--h5-order-detail-page-padding-bottom" as string]: `${pagePaddingBottom}px`,
  };
}
